import { ShippingClaimSchema } from "@redotech/redo-model/shipping-claims/shipping-claim";
import * as z from "zod/v4";

export const getMerchantShippingClaim = {
  name: "getMerchantShippingClaim" as const,
  input: z.object({ claimId: z.string() }),
  output: ShippingClaimSchema,
};
